import * as React from "react"

import { isProduct, ICategoryOrProduct } from "shared/hubrise/models"
import type { TagOption } from "shared/hubrise/utils/tags"

import CategoryContent from "./CategoryContent"
import ProductContent from "./ProductContent"

const Content = ({
  categoryOrProduct,
  tagOptions,
}: {
  categoryOrProduct: ICategoryOrProduct
  tagOptions: Array<TagOption>
}): JSX.Element =>
  isProduct(categoryOrProduct) ? (
    <ProductContent product={categoryOrProduct} tagOptions={tagOptions} />
  ) : (
    <CategoryContent category={categoryOrProduct} />
  )

export default React.memo(Content)
